<web-widget-breadcrumbs [widget]="widget()" [isInSpecificSection]="isSpecific()" [hideBreadcrumbs]="isZero" />

<div class="panel-options-body overflow-wrapper" (click)="blurEditor()">
    <div class="form form-horizontal">
        @if (!isZero) {
            <div class="form-row mb-20">
                <div class="form-group">
                    <label class="control-label col-xs-7">
                        {{ "control_content_alignment" | translate }}
                    </label>
                    <div class="col-xs-5">
                        <sp-radio-group
                            [selected]="form?.horizontalAlign().value()"
                            [type]="ERadioGroupType.horizontalPosition"
                            (changeSelectedEvent)="setHorizontalAlign($event)"
                        />
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group mb-10">
                    <div class="col-xs-12 device-toggle-wrapper">
                        <web-device-toggle />
                        <web-synchronize-style-toggle
                            [active]="form.isSynchronized()"
                            (click)="setSynchronizeStyle()"
                        />
                    </div>
                </div>
            </div>

            <div class="form-group mb-0">
                @if (isDeviceDesktopSig()) {
                    <p class="col-xs-12 help-block text-muted small">{{ "desktop_device_hint" | translate }}</p>
                }
                @if (isDeviceTabletSig()) {
                    <p class="col-xs-12 help-block text-muted small">{{ "tablet_device_hint" | translate }}</p>
                }
                @if (isDeviceMobileSig()) {
                    <p class="col-xs-12 help-block text-muted small">{{ "mobile_device_hint" | translate }}</p>
                }
            </div>
        }

        @if (isZero) {
            <!--
                No height editor: a zero text widget's height is derived — the view measures the
                rendered editor and writes it back into the position grid, so any value typed here
                is overwritten on the next measurement.
            -->
            <sp-extended-position-signal-settings
                [position]="zeroPosition()"
                [showWidth]="true"
                [showHeight]="false"
                [isMobile]="isDeviceMobileSig()"
                [isTablet]="isDeviceTabletSig()"
                [parentId]="widget().columnId"
                (valueChangeEvent)="zeroForm.setPosition($event)"
            />
        } @else {
            <web-widget-position-settings
                [isSynchronized]="form.isSynchronized()"
                [isTablet]="isDeviceTabletSig()"
                [isMobile]="isDeviceMobileSig()"
                [showWidth]="true"
                [widgetId]="widget().id"
                [columnId]="widget().columnId"
                [position]="defaultPosition()"
                (positionChange)="onDefaultPositionChange($any($event))"
            />
        }

        <div class="form-group mb-0">
            <div class="col-xs-12">
                <hr class="panel-options-divider" />
            </div>
        </div>

        @if (isZero) {
            <web-widget-extended-hide-settings
                [hideOnDesktop]="form.hideOnDesktop().value()"
                [hideOnTablet]="form.hideOnTablet().value()"
                [hideOnMobile]="form.hideOnMobile().value()"
                (hideOnDesktopChange)="setHideOnDesktop($event)"
                (hideOnTabletChange)="setHideOnTablet($event)"
                (hideOnMobileChange)="setHideOnMobile($event)"
            />
        } @else {
            <web-widget-hide-settings
                [hideOnDesktop]="form.hideOnDesktop().value()"
                [hideOnTablet]="form.hideOnTablet().value()"
                [hideOnMobile]="form.hideOnMobile().value()"
                (hideOnDesktopChange)="setHideOnDesktop($event)"
                (hideOnTabletChange)="setHideOnTablet($event)"
                (hideOnMobileChange)="setHideOnMobile($event)"
            />
        }

        <div class="form-group mb-0">
            <div class="col-xs-12">
                <hr class="panel-options-divider" />
            </div>
        </div>

        @if (!isSpecific()) {
            <div class="form-row">
                <sp-animation-settings-signal-legacy
                    [animation]="form?.animation().value()"
                    [showRunningStripe]="true"
                    (valueChangeEvent)="form.setAnimation($event)"
                />
            </div>
        }

        <div [class.mt-20]="!isSpecific()">
            <web-custom-id [displayId]="form?.displayId()" (valueChangeEvent)="form?.setDisplayId($event)" />
        </div>
    </div>
</div>
